import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient} from '@tanstack/react-query'

import {RcfaComment} from '../comments.types'

export type ResponseType = {
  data: boolean
}

import {GetCommentsQueryKey} from './commentQueryKeys'

export const useEditComment = (analysisId: string | undefined, nodeId: number) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (commentUpdateData: RcfaComment) => {
      const path = `/rootcausefailureanalysis/analyses/${analysisId}/tree/nodes/${nodeId}/comments/${commentUpdateData.id}`
      return (await ApiClient.axiosInstance.patch<number>(path, {text: commentUpdateData.text}))
        .status
    },
    onSuccess: async (data: number) => {
      await queryClient.invalidateQueries({queryKey: [GetCommentsQueryKey]})
      await queryClient.invalidateQueries({queryKey: ['analysis-detail']})
      return data
    }
  })
}
